import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Mail, Phone, User, Calendar, MessageSquare } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminEnquiries = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEnquiries();
  }, []);

  const fetchEnquiries = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/contact-submissions`);
      setEnquiries(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching enquiries:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0a0a0c] flex items-center justify-center">
        <p className="text-white">Loading enquiries...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0a0a0c] py-12 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-10">
          <h1 
            className="text-4xl font-serif text-white mb-2"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Contact Form Enquiries
          </h1>
          <p className="text-white/60">
            Total Enquiries: <span className="text-[#FF8C42] font-bold">{enquiries.length}</span>
          </p>
        </div>

        {/* Enquiries List */}
        {enquiries.length === 0 ? (
          <div className="bg-[#1a1a1c] rounded-lg p-12 text-center">
            <p className="text-white/60">No enquiries yet</p>
          </div>
        ) : (
          <div className="space-y-6">
            {enquiries.map((enquiry, index) => (
              <div 
                key={enquiry.id || index}
                className="bg-[#1a1a1c] rounded-lg p-6 hover:shadow-lg hover:shadow-[#FF8C42]/10 transition-all"
              >
                {/* Header */}
                <div className="flex items-start justify-between mb-4 pb-4 border-b border-white/10">
                  <div className="flex items-center gap-3">
                    <User size={20} className="text-[#FF8C42]" />
                    <h3 className="text-xl text-white font-medium">{enquiry.name}</h3>
                  </div>
                  <div className="flex items-center gap-2 text-white/50 text-sm">
                    <Calendar size={16} />
                    <span>
                      {enquiry.timestamp 
                        ? new Date(enquiry.timestamp).toLocaleDateString('en-IN', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                          })
                        : 'Recent'}
                    </span>
                  </div>
                </div>

                {/* Contact Info */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div className="flex items-center gap-3">
                    <Mail size={18} className="text-[#FF8C42]" />
                    <a 
                      href={`mailto:${enquiry.email}`}
                      className="text-white/70 hover:text-[#FF8C42] transition-colors"
                    >
                      {enquiry.email}
                    </a>
                  </div>
                  <div className="flex items-center gap-3">
                    <Phone size={18} className="text-[#FF8C42]" />
                    <a 
                      href={`tel:${enquiry.phone}`}
                      className="text-white/70 hover:text-[#FF8C42] transition-colors"
                    >
                      {enquiry.phone}
                    </a>
                  </div>
                </div>

                {/* Message */}
                <div className="bg-[#0a0a0c] rounded p-4">
                  <div className="flex items-start gap-3 mb-2">
                    <MessageSquare size={18} className="text-[#FF8C42] mt-1" />
                    <p className="text-white/60 text-sm font-medium">Project Details:</p>
                  </div>
                  <p className="text-white/80 leading-relaxed pl-9">
                    {enquiry.message}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminEnquiries;
